import { useQuery } from '@tanstack/react-query';
import { evidenceSlotService } from '@services/evidenceSlot';

export const EVIDENCE_SLOTS_QUERY_KEY = 'evidenceSlots';

/** Sprint 11, story-042 (U77). Task-level slot state. */
export const useEvidenceSlotsForTask = (taskId?: string) => {
  return useQuery({
    queryKey: [EVIDENCE_SLOTS_QUERY_KEY, 'task', taskId],
    queryFn: () => evidenceSlotService.getForTask(taskId as string),
    enabled: Boolean(taskId),
    staleTime: 60 * 1000,
  });
};

/** Directly-attached project-level slot state (document.projectId set, taskId null). */
export const useEvidenceSlotsForProject = (projectId?: string) => {
  return useQuery({
    queryKey: [EVIDENCE_SLOTS_QUERY_KEY, 'project', projectId],
    queryFn: () => evidenceSlotService.getForProject(projectId as string),
    enabled: Boolean(projectId),
    staleTime: 60 * 1000,
  });
};

/** Per-task breakdown for a project — what the project-level Evidence tab renders. */
export const useEvidenceSlotsByProject = (projectId?: string) => {
  return useQuery({
    queryKey: [EVIDENCE_SLOTS_QUERY_KEY, 'byProject', projectId],
    queryFn: () => evidenceSlotService.getByProject(projectId as string),
    enabled: Boolean(projectId),
    staleTime: 60 * 1000,
  });
};

export default useEvidenceSlotsForTask;
